import React, { useState } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import MenuItem from "@mui/material/MenuItem";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { ListItemIcon } from "@mui/material";
import MailOutlineOutlinedIcon from "@mui/icons-material/MailOutlineOutlined";
import Person2OutlinedIcon from "@mui/icons-material/Person2Outlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { useNavigate } from "react-router-dom";

export default function Header() {
  const [anchorElUser, setAnchorElUser] = useState(null);
  const navigate = useNavigate();

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleLogout = () => {
    navigate("/logout");
  };
  return (
    <AppBar
      color="inherit"
      position="static"
      sx={{
        boxShadow: "none !important",
      }}
    >
      <Container
        maxWidth="xxl"
        sx={{
          padding: "16px 20px",
        }}
      >
        <Box
          sx={{
            // padding:"16px 20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <Typography
            sx={{ color: "#151D48", fontSize: "24px", fontWeight: "500" }}
          ></Typography>
          <Box sx={{ flexGrow: 0 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <Avatar
                alt={localStorage.getItem("firstName")}
                src=""
                variant="rounded"
                sx={{ bgcolor: "orange", width: 48, height: 48 }}
              />{" "}
              <Box
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "start",
                }}
              >
                <IconButton
                  onClick={handleOpenUserMenu}
                  sx={{
                    px: 1,
                    py: 0.2,
                    cursor: "pointer",
                    textTransform: "capitalize",
                    borderRadius: "0",
                  }}
                >
                  <Typography
                    sx={{
                      color: "#151D48",
                      fontSize: "14px",
                      fontWeight: "600",
                    }}
                  >
                    {localStorage.getItem("firstName")}
                    {/* {"Site-Admin Name"} */}
                  </Typography>
                  <KeyboardArrowDownIcon sx={{ ml: 1 }} />
                </IconButton>
                <Typography
                  sx={{
                    color: "#737791",
                    fontSize: "12px",
                    mx: 1,
                  }}
                >
                  {"SITE-ADMIN"}
                </Typography>
              </Box>
            </Box>
            <Menu
              sx={{
                mt: "45px",
                "& .MuiPaper-root": {
                  borderRadius: "0px 0px 20px 20px",
                  top: "42px !important",
                },
              }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              <MenuItem
                sx={{
                  cursor: "default",
                  ":hover": { backgroundColor: "white" },
                  pointerEvents: "none",
                  marginBottom: "8px",
                }}
              >
                <ListItemIcon>
                  <Person2OutlinedIcon />
                </ListItemIcon>
                {/* {localStorage.getItem("role")} */}
                {"SITE-ADMIN"}
              </MenuItem>
              <MenuItem
                sx={{
                  borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
                  cursor: "default",
                  ":hover": { backgroundColor: "white" },
                  pointerEvents: "none",
                  marginBottom: "14px",
                }}
              >
                <ListItemIcon>
                  <MailOutlineOutlinedIcon />
                </ListItemIcon>
                <Typography textAlign="start">
                  {localStorage.getItem("email")}
                </Typography>
              </MenuItem>
              <MenuItem onClick={handleLogout}>
                <ListItemIcon>
                  <LogoutOutlinedIcon />
                </ListItemIcon>
                <Typography textAlign="start">Logout</Typography>
              </MenuItem>
            </Menu>
          </Box>
        </Box>
        {/* </Toolbar> */}
      </Container>
    </AppBar>
  );
}
